import { usePathAndData } from "../../../hook/usePathAndData";
import { AppLayout } from "../../layout/AppLayout";
import { CopiaCotizacion } from "../../view/cotizaciones/CopiaCotizacion";
import { CrearCotizacion } from "../../view/cotizaciones/CrearCotizacion";
import { EditarCotizacion } from "../../view/cotizaciones/EditarCotizacion";
import { ListaCotizacion } from "../../view/cotizaciones/ListaCotizacion";
import { VerCotizacion } from "../../view/cotizaciones/VerCotizacion";


export const PageCotizaciones = () => {
    const { path, dataValue } = usePathAndData(); // Usa el hook

    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "cotizaciones" && path[2] === "lista" && <ListaCotizacion />}
                                {path[1] === "cotizaciones" && path[2] === "crear" && <CrearCotizacion />}
                                {path[1] === "cotizaciones" && path[2] === "view" && <VerCotizacion />}
                                {path[1] === "cotizaciones" && path[2] === "editar" && <EditarCotizacion />}
                                {path[1] === "cotizaciones" && path[2] === "copia" && <CopiaCotizacion/>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
